import _ from 'lodash'
import Backbone from 'backbone'
import calendars from 'scoreboard/components/calendars'
import dropdown from 'scoreboard/components/dropdown'
import i18n from 'scoreboard/components/i18n'
import selects from 'scoreboard/components/selects'
import template from './metric-update-filter.hbs'

var MetricUpdateFilter = Backbone.View.extend({

	events: {
		'change .organization, .frequency': '_onChange'
	},

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template())

		const options = _.map(this.options.orgs, ({id, label}) => {
			return {
				id,
				label,
				selected: id == this.options.orgId
			}
		})
		selects.filtering(this.$('[name=organizationId]'), {
			options,
			accessors: {
				value: 'id'
			},
			sort: [] //already sorted the way we want
		})

		let calendarOptions = _.cloneDeep(calendars.calendars)
		calendarOptions.unshift({
			label: i18n.get('home.metricUpdates.allCalendars'),
			id: -1
		})
		dropdown.idLabels(this.$('[name=calendarId]'), calendarOptions, this.options.calendarId)

		return this
	},

	_onChange: function() {
		this.trigger('change',
			parseInt(this.$('[name=organizationId]').val()),
			parseInt(this.$('[name=calendarId]').val()))
	}
})

export default MetricUpdateFilter

MetricUpdateFilter.__filename__ = 'home/metric-updates/metric-update-filter.js'
